/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return */
// TODO: Add proper types for render function props and section data
import { computed, defineComponent, h, toRefs } from 'vue'

const DefaultSection = defineComponent({
  name: 'DefaultSection',
  props: {
    section: {
      type: Object,
      required: true,
    },
    currentItem: {
      type: Object,
      required: false,
      default: null,
    },
    renderSuggestion: {
      type: Function,
      default: null,
      required: false,
    },
    normalizeItemFunction: {
      type: Function,
      required: true,
    },
    componentAttrPrefix: {
      type: String,
      required: true,
    },
    componentAttrIdAutosuggest: {
      type: String,
      required: true,
    },
  },
  emits: ['updateCurrentItem'],
  setup(props, { slots: $slots, emit }) {
    const {
      section,
      currentItem,
      renderSuggestion,
      normalizeItemFunction,
      componentAttrPrefix,
      componentAttrIdAutosuggest,
    } = toRefs(props)

    const isHighlighted = (item: any) => {
      return currentItem.value?.item === item
    }

    const onMouseEnter = (item: any) => {
      const normalizedItem = normalizeItemFunction.value(
        section.value.name,
        section.value.type,
        section.value.label,
        section.value.liClass,
        item,
      )
      emit('updateCurrentItem', normalizedItem)
    }

    const list = computed(() => {
      let { limit } = section.value
      const { data } = section.value
      if (data.length < limit) {
        limit = data.length
      }
      return data.slice(0, limit)
    })

    const slots = {
      beforeSection: $slots[`before-section-${section.value.name}`],
      afterSectionDefault: $slots['after-section'],
      afterSectionNamed: $slots[`after-section-${section.value.name}`],
    }

    return () =>
      h(
        'ul',
        {
          role: 'listbox',
          class: section.value.ulClass,
          'aria-labelledby':
            section.value.label &&
            `${componentAttrIdAutosuggest.value}-${section.value.label}`,
        },
        [
          slots.beforeSection &&
            h(
              'li',
              slots.beforeSection({
                section: section.value,
                className: `${componentAttrPrefix.value}__results-before ${componentAttrPrefix.value}__results-before--${section.value.name}`,
              }),
            ),
          list.value.map((val, key) => {
            const item = normalizeItemFunction.value(
              section.value.name,
              section.value.type,
              section.value.label,
              section.value.liClass,
              val,
            )

            return h(
              'li',
              {
                role: 'option',
                'data-section-name': item.name,
                id: `${componentAttrPrefix.value}__results-item--${key}`,
                ...item.liAttributes,
                key:
                  val.slug ||
                  val.path ||
                  val.mapboxId ||
                  val.url ||
                  `${section.value.name}-${key}`,
                class: {
                  [`${componentAttrPrefix.value}__results-item--highlighted`]:
                    isHighlighted(val),
                  [`${componentAttrPrefix.value}__results-item`]: true,
                  ...item.liClass,
                },
                onMouseenter: () => onMouseEnter(val),
                onMouseleave: () => emit('updateCurrentItem', null),
              },
              [
                renderSuggestion.value
                  ? renderSuggestion.value(item)
                  : $slots.default &&
                    $slots.default({
                      _key: key,
                      suggestion: item,
                    }),
              ],
            )
          }),
          slots.afterSectionDefault &&
            h(
              'li',
              slots.afterSectionDefault({
                section: section.value,
                className: `${componentAttrPrefix.value}__results-after ${componentAttrPrefix.value}__results-after--${section.value.name}`,
              }),
            ),
          slots.afterSectionNamed &&
            h(
              'li',
              slots.afterSectionNamed({
                section: section.value,
                className: `${componentAttrPrefix.value}__results_after ${componentAttrPrefix.value}__results-after--${section.value.name}`,
              }),
            ),
        ],
      )
  },
  methods: {
    getItemByIndex: function (i) {
      return this.section.data[i]
    },
  },
})

export default DefaultSection
